import { Injectable, Inject } from '@angular/core';
import { appHttpClient } from '@framework';
import { ProjectModel } from '@models';
import { environment as env } from 'environments/environment';

@Injectable()
export class ProjectServices {
    private get _endpoint() { return env.app_apiURL + '/projects' }

    constructor(@Inject('appHttpClient') private _httpClient: appHttpClient) { }

    Find(_Project?: ProjectModel) {

        let _endpoint = this._endpoint;
        if (_Project) {
            _endpoint += '?' + _Project.toQueryParamData();
        }
        return this._httpClient.Get(_endpoint).map(res => res.json());
    }

    //CREATE NEW PROJECT
    Insert(_Project?: ProjectModel): any {
        return this._httpClient.Post(`${this._endpoint}`, JSON.stringify(_Project));
    }

    //UPDATE PROJECT

    //

    getProjectInstances(_ProjectID) {
        const _endpoint = this._endpoint + `/${_ProjectID}/instances`
        return this._httpClient.Get(_endpoint)
            .map((res) => res.json());
    }

    getProjectInstance(_InstanceID) {
        const _endpoint = this._endpoint + `/instance/${_InstanceID}`
        return this._httpClient.Get(_endpoint)
            .map((res) => res.json());
    }


    getProjectRoutes(_ProjectID) {
        const _endpoint = this._endpoint + `/${_ProjectID}/routes`
        return this._httpClient.Get(_endpoint)
            .map((res) => res.json());
    }
 
    getProjectMenu(_ProjectID) {
        const _endpoint = this._endpoint + `/${_ProjectID}/menu`
        return this._httpClient.Get(_endpoint)
            .map((res) => res.json());
    }

};
